import { Injectable, signal } from '@angular/core';


@Injectable({ providedIn: 'root' })
export class ForbiddenService {

    // -----------------------------------------------------------------------------------------------------
    // @ PRIVATE INSTANCE PROPERTIES
    // -----------------------------------------------------------------------------------------------------

    /**
     * Indicates whether the user is forbidden from accessing a resource. This can be used to show a forbidden page or message to the user.
     */
    private readonly _isForbidden = signal<boolean>(false);

    // -----------------------------------------------------------------------------------------------------
    // @ PUBLIC INSTANCE PROPERTIES
    // -----------------------------------------------------------------------------------------------------

    /**
     * Publicly accessible if the user is forbidden from accessing a resource. This can be used to show a forbidden page or message to the user.
     */
    readonly isForbidden = this._isForbidden.asReadonly();

    // -----------------------------------------------------------------------------------------------------
    // @ PUBLIC METHODS
    // -----------------------------------------------------------------------------------------------------

    /**
     * Forbids the user from accessing a resource. This can be used to show a forbidden page or message to the user.
     * 
     * @returns {void}
     */
    forbid(): void {
        this._isForbidden.set(true);
    }

    /**
     * Allows the user to access a resource. This can be used to hide a forbidden page or message from the user.
     * 
     * @returns {void}
     */
    allow(): void {
        this._isForbidden.set(false);
    }
}